import script from "./sf-accordion-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-accordion-item.vue?vue&type=script&lang=ts&setup=true"

import "./sf-accordion-item.vue?vue&type=style&index=0&id=103a2443&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-103a2443"]])

export default __exports__